<template>
  <div>
    <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      留言列表
    </h3>
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%">
      <el-table-column
        prop="name"
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        prop="email"
        label="电子邮箱"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话"
      >
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名称"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="使用地址"
      >
      </el-table-column>
      <el-table-column
        prop="description"
        label="需求描述"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="留言时间"
        width="160px"
      >
      </el-table-column>

      <el-table-column
        label="备注"
        prop="remark"
      >

      </el-table-column>
      <el-table-column
        label="操作"
        width="120px"
      >
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">备注</el-button>
          <el-button v-if="scope.row.processed" type="text" size="small">已处理</el-button>
          <el-button v-else @click="handleProcess(scope.row)" type="text" size="small">处理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="备注" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="内容" label-width="120px">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "ApplyManage",
    methods: {
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.loadData('?current='+val+'&size='+this.pageSize);
      },
      flushPage(){
        this.loadData('?current='+this.currentPage+'&size='+this.pageSize);
      },
      handleEdit(row){
        // 这里需要把row的数据拷贝一份，不然在编辑栏编辑的时候回改动列表的数据
        this.form = JSON.parse(JSON.stringify(row))
        this.dialogFormVisible = true;
      },
      handleProcess(row){
        const self = this
        row.type='tech'
        row.processed = true
        let postData = self.$qs.stringify(row)
        self.$http.post(self.$host+'apply/update',
          postData
        ).then(function (response) {
          self.$common.loginCheck(response.data.content)
          self.dialogFormVisible = false
          self.flushPage();
        }).catch(e => {
          console.log(e)
        })
      },
      submit(){
        const self = this
        this.form.type='tech'
        let postData = self.$qs.stringify(this.form)
        self.$http.post(self.$host+'apply/update',
          postData
        ).then(function (response) {
          self.$common.loginCheck(response.data.content)
          self.dialogFormVisible = false
          self.flushPage();
        }).catch(e => {
          console.log(e)
        })
      },
      loadData(params) {
        const self = this
        let postData =
          self.$qs.stringify({
          })
        if(!params){
          params = '';
        }
        self.$http.post(self.$host+'apply/page'+params,
          postData
        ).then(function (response) {
          self.tableData = response.data.content.records;
          self.pageSize = response.data.content.size;
          self.total = response.data.content.total;
          self.currentPage = response.data.content.current;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    data() {
      return {
        tableData:[],
        currentPage: 1,
        pageSize:10,
        total:1,
        dialogFormVisible:false,
        form:{},
      };
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/manage/ApplyManage.vue